import { createElement } from 'react';
import { toast, ToastContent, ToastOptions } from 'react-toastify';
import { TOAST_CONFIG } from '@constants/common';

export const toastMessage = (title: string, subtitle?: string): ToastContent =>
  subtitle
    ? createElement(
        'span',
        null,
        createElement('strong', null, title),
        ' ',
        createElement('span', { className: 'font-medium md:block' }, subtitle),
      )
    : title;

export const notifySuccess = (message: ToastContent, options?: ToastOptions) =>
  toast(message, {
    ...TOAST_CONFIG,
    type: 'success',
    className: 'toastify-hb-success',
    ...options,
  });

export const notifyError = (message: ToastContent, options?: ToastOptions) =>
  toast(message, {
    ...TOAST_CONFIG,
    type: 'error',
    className: 'toastify-hb-error',
    ...options,
  });
